import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gdp-internal-facilities-main',
  templateUrl: './internal-facilities-main.component.html'
})
export class InternalFacilitiesMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
